import type { GridSortModel } from "@mui/x-data-grid";

import type { IGetMarketsByEventIdRequestParams } from "~/feature/dashboard/types";
import { MarketsDataGridField } from "~/feature/event/components/MarketsDataGrid/types";
import { MarketSortByEnum } from "~/types/event";
import { SortOrderEnum } from "~/types/sort";

const marketSortByByGridField: Partial<
  Record<MarketsDataGridField, MarketSortByEnum>
> = {
  [MarketsDataGridField.Market]: MarketSortByEnum.TITLE,
  [MarketsDataGridField.Chance]: MarketSortByEnum.CHANCE,
  [MarketsDataGridField.Price]: MarketSortByEnum.PRICE,
  [MarketsDataGridField.Liquidity]: MarketSortByEnum.LIQUIDITY,
  [MarketsDataGridField.Volume]: MarketSortByEnum.VOLUME,
  [MarketsDataGridField.H24]: MarketSortByEnum.VOLUME24PERC,
  [MarketsDataGridField.D7]: MarketSortByEnum.VOLUME7PERC,
  [MarketsDataGridField.EndsIn]: MarketSortByEnum.END_DATE,
  [MarketsDataGridField.OpenInterest]: MarketSortByEnum.OPEN_INTEREST,
  [MarketsDataGridField.Status]: MarketSortByEnum.RESULT,
};

export const backendSortParamsFromMarketsSortModel = (
  sortModel: GridSortModel
): Pick<IGetMarketsByEventIdRequestParams, "sortBy" | "sortOrder"> => {
  const item = sortModel[0];
  if (!item?.field || !item.sort) return {};

  const sortBy = marketSortByByGridField[item.field as MarketsDataGridField];
  if (!sortBy) return {};

  const sortOrder =
    item.sort === "asc" ? SortOrderEnum.ASC : SortOrderEnum.DESC;

  return { sortBy, sortOrder };
};
